import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

const termSections = [
  {
    id: "terms-scope",
    number: "01",
    title: "Geltungsbereich",
    content: (
      <>
        <p>
          Diese Allgemeinen Geschäftsbedingungen gelten für Bestellungen, die
          Verbraucherinnen und Verbraucher über diesen Onlineshop abgeben.
          Abweichende Bedingungen gelten nur, wenn sie ausdrücklich vereinbart
          wurden.
        </p>
        <p>
          Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft
          überwiegend zu Zwecken abschließt, die weder ihrer gewerblichen noch
          ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden können.
        </p>
      </>
    ),
  },
  {
    id: "terms-contract",
    number: "02",
    title: "Bestellung und Vertragsschluss",
    content: (
      <>
        <p>
          Die Darstellung von Artikeln im Shop ist noch kein verbindliches
          Angebot. Du legst Artikel zunächst unverbindlich in den Warenkorb und
          kannst deine Eingaben bis zum Absenden der Bestellung korrigieren.
        </p>
        <ol>
          <li>Artikel, Farbe, Größe und Menge auswählen.</li>
          <li>Liefer- und Kontaktdaten prüfen.</li>
          <li>Zahlungsart wählen und Bestellübersicht kontrollieren.</li>
          <li>Bestellung zahlungspflichtig absenden.</li>
        </ol>
        <p>
          Der Vertrag kommt zustande, sobald wir die Bestellung annehmen. Die
          Annahme erfolgt durch eine ausdrückliche Auftragsbestätigung oder durch
          Versand der Ware.
        </p>
      </>
    ),
  },
  {
    id: "terms-prices",
    number: "03",
    title: "Preise und Zahlung",
    content: null,
  },
  {
    id: "terms-delivery",
    number: "04",
    title: "Lieferung und Eigentumsvorbehalt",
    content: (
      <>
        <p>
          Liefergebiet, Versandkosten und die voraussichtliche Lieferzeit werden
          im Shop und vor Abschluss der Bestellung angezeigt. Sollte ein Artikel
          ausnahmsweise nicht verfügbar sein, informieren wir dich unverzüglich.
        </p>
        <p>
          Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum. Bitte
          prüfe das Paket bei Erhalt auf offensichtliche Transportschäden. Deine
          gesetzlichen Ansprüche bleiben auch bestehen, wenn du einen Schaden
          nicht sofort meldest.
        </p>
      </>
    ),
  },
  {
    id: "terms-cancellation",
    number: "05",
    title: "Widerruf und Retoure",
    content: (
      <>
        <p>
          Verbraucherinnen und Verbraucher haben grundsätzlich ein gesetzliches
          Widerrufsrecht. Einzelheiten zu Frist, Ausübung und Folgen ergeben sich
          aus der Widerrufsbelehrung, die im Bestellprozess bereitgestellt wird.
        </p>
        <p>
          Ergänzende Hinweise zur praktischen Rücksendung, zu Ausnahmen und zur
          Erstattung findest du auf unserer Retourenseite.
        </p>
        <Link className="terms__inline-link" to="/returns">
          Zu Retoure &amp; Erstattung <span aria-hidden="true">→</span>
        </Link>
      </>
    ),
  },
  {
    id: "terms-warranty",
    number: "06",
    title: "Mängelrechte und Haftung",
    content: (
      <>
        <p>
          Es gelten die gesetzlichen Mängelrechte. Bitte wende dich an unseren
          Service, wenn ein Artikel nicht der Beschreibung entspricht oder einen
          Fehler aufweist. Wir suchen eine faire und zügige Lösung.
        </p>
        <p>
          Für Schäden aus der Verletzung von Leben, Körper oder Gesundheit sowie
          bei Vorsatz und grober Fahrlässigkeit haften wir nach den gesetzlichen
          Vorschriften. Bei leicht fahrlässiger Verletzung wesentlicher
          Vertragspflichten ist die Haftung auf den typischerweise vorhersehbaren
          Schaden begrenzt, soweit gesetzlich zulässig.
        </p>
      </>
    ),
  },
  {
    id: "terms-final",
    number: "07",
    title: "Schlussbestimmungen",
    content: (
      <>
        <p>
          Vertragssprache ist Deutsch. Es gilt das Recht der Bundesrepublik
          Deutschland unter Ausschluss des UN-Kaufrechts. Zwingende
          Verbraucherschutzvorschriften des Landes, in dem du deinen gewöhnlichen
          Aufenthalt hast, bleiben unberührt.
        </p>
        <p>
          Sollte eine einzelne Regelung unwirksam sein, bleiben die übrigen
          Bestimmungen davon unberührt. Gesetzliche Regelungen treten an die
          Stelle einer unwirksamen Bestimmung.
        </p>
      </>
    ),
  },
];

function Terms() {
  const { brandName, currency, contact = {} } = siteConfig;
  const { email, phone, phoneHref, address } = contact;

  return (
    <main className="terms">
      <header className="terms__hero">
        <nav className="terms__breadcrumb" aria-label="Brotkrümelnavigation">
          <Link to="/">Startseite</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">AGB</span>
        </nav>
        <div className="terms__hero-grid">
          <div>
            <p className="terms__eyebrow">Klar und fair geregelt</p>
            <h1>Allgemeine Geschäftsbedingungen</h1>
          </div>
          <div className="terms__hero-copy">
            <p>
              Diese Bedingungen bilden die Grundlage für einen transparenten
              Einkauf bei {brandName}. Die wichtigsten Schritte und Rechte sind
              hier verständlich zusammengefasst.
            </p>
            <span>Stand: August 2026</span>
          </div>
        </div>
      </header>

      <div className="terms__body">
        <nav className="terms__index" aria-label="Inhaltsverzeichnis">
          <p>Inhalt</p>
          <ol>
            {termSections.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>
                  <span>{section.number}</span>
                  {section.title}
                </a>
              </li>
            ))}
          </ol>
        </nav>

        <article className="terms__article">
          {termSections.map((section) => (
            <section id={section.id} key={section.id}>
              <span className="terms__number" aria-hidden="true">
                {section.number}
              </span>
              <h2>{section.title}</h2>
              {section.id === "terms-prices" ? (
                <>
                  <p>
                    Alle im Shop genannten Preise verstehen sich in {currency}
                    und enthalten die gesetzliche Umsatzsteuer. Zusätzlich
                    anfallende Versandkosten werden vor Absenden der Bestellung
                    deutlich ausgewiesen.
                  </p>
                  <div className="terms__payment-grid" aria-label="Zahlungsablauf">
                    <div>
                      <strong>Zahlungsart</strong>
                      <p>Die verfügbaren Optionen werden im Checkout angezeigt.</p>
                    </div>
                    <div>
                      <strong>Fälligkeit</strong>
                      <p>Der Zeitpunkt richtet sich nach der gewählten Zahlungsart.</p>
                    </div>
                    <div>
                      <strong>Sicherheit</strong>
                      <p>Zahlungsdaten werden geschützt übertragen und nicht im Warenkorb gespeichert.</p>
                    </div>
                  </div>
                </>
              ) : (
                section.content
              )}
            </section>
          ))}

          <section className="terms__contact" aria-labelledby="terms-contact-title">
            <p className="terms__eyebrow">Noch etwas unklar?</p>
            <h2 id="terms-contact-title">Wir helfen dir weiter.</h2>
            <address>
              <strong>{brandName}</strong>
              {address && <span>{address}</span>}
              {email && <a href={`mailto:${email}`}>{email}</a>}
              {phone && (
                    <a href={`tel:${phoneHref || phone.replace(/[^+\d]/g, "")}`}>
                      {phone}
                    </a>
              )}
            </address>
            <Link className="terms__button" to="/contact">
              Kontakt aufnehmen
            </Link>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
